import CoreStyles from "@/assets/js/core-playing-styles";
import AttackingStyles from "@/assets/js/attacking-styles";


export default {
  centralAttack: {
    highRiskDirect: () => true,

    highRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },

    interchanging: () => true,

    mediumRiskDirect: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.attacking ||
        attackingStyle === AttackingStyles.directPlays
      );
    },

    mediumRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },
  },

  centralMidfield: {
    lowRiskDirect: () => true,

    mediumRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },

    mediumRiskDirect: () => true,

    interchanging: () => true,

    highRiskDirect: () => true,

    highRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },
  },

  flanks: {
    highRiskDirect: () => true,

    highRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },

    interchanging: () => true,

    mediumRiskDirect: () => true,

    mediumRiskOverlapping: (coreStyle, attackingStyle) => {
      return (
        coreStyle !== CoreStyles.defensive ||
        attackingStyle === AttackingStyles.shortPlays
      );
    },
  }
}
